import { Configurable } from 'models'

const configurableOptions: Configurable = {
  locale: 'ru',
  buildTarget: (process.env.REACT_APP_BUILD_TARGET ||
    'homepage') as Configurable['buildTarget'],
  links: {
    homepage: process.env.REACT_APP_LINK_URL_HOME,
    Главная: process.env.REACT_APP_LINK_URL_HOME,
    Татары: process.env.REACT_APP_LINK_URL_TATARSTAN,
    Коми: process.env.REACT_APP_LINK_URL_KOMI,
    Бурятия: process.env.REACT_APP_LINK_URL_BURYATIYA,
    Caxa: process.env.REACT_APP_LINK_URL_CAXA,
    Erzya: process.env.REACT_APP_LINK_URL_ERZYA,
  },
}

export const config = {
  ...configurableOptions,
  imgUrl: process.env.REACT_APP_IMG_URL,
  yearNow: new Date(Date.now()).getFullYear(),
  buildTarget: (new URLSearchParams(document.location.search).get('page') ||
    configurableOptions.buildTarget) as Configurable['buildTarget'],
}
